import { render, staticRenderFns } from "./SectionBox.vue?vue&type=template&id=21b310d8&scoped=true&"
import script from "./SectionBox.vue?vue&type=script&lang=js&"
export * from "./SectionBox.vue?vue&type=script&lang=js&"
import style0 from "./SectionBox.vue?vue&type=style&index=0&id=21b310d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b310d8",
  null
  
)

export default component.exports